export function createCounterProposalUrl(id: string) {
  return `/?widget=interest&id=${id}&step=propose`;
}
